import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

import type {
  SkuReviewSummaryResponseType,
  GoodValueOverviewParamsType,
  GoodValueOverviewResponseType,
  TrendOverviewParamsType,
  TrendOverviewResponseType,
  ForecastProductListResponseType,
  HubDistributionParamsType,
  HubDistributionResponseType,
  ExportForecastParamsType,
} from '../@types/dpTypes'

import type { ForecastProductListParamsType } from '../@types/forecastFilterTypes'

const ANALYTICS_BASE = '/analytics-data/internal/v1'

export const getSkuReviewSummary = (params?: ForecastProductListParamsType) =>
  axiosInstanceApiGateway.Get<SkuReviewSummaryResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/sku-review-summary`,
    params,
  })

export const getGoodValueOverview = (params: GoodValueOverviewParamsType) =>
  axiosInstanceApiGateway.Get<GoodValueOverviewResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/good-value-overview`,
    params,
  })

export const getTrendOverview = (params: TrendOverviewParamsType) =>
  axiosInstanceApiGateway.Get<TrendOverviewResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/trend-overview`,
    params,
  })

export const getForecastProductList = (params?: ForecastProductListParamsType) =>
  axiosInstanceApiGateway.Get<ForecastProductListResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts`,
    params,
  })

export const getForecastProductListByHubId = (params?: ForecastProductListParamsType) =>
  axiosInstanceApiGateway.Get<ForecastProductListResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/product-hub`,
    params,
  })

export const getHubDistribution = (productId: number, params?: HubDistributionParamsType) =>
  axiosInstanceApiGateway.Get<HubDistributionResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products/${productId}/hub-distribution`,
    params,
  })

export const exportForecast = (params: ExportForecastParamsType) =>
  axiosInstanceApiGateway.Post<{ file_url: string }, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/export`,
    params,
  })
